module.exports = __webpack_public_path__ + "static/media/building.e506f392.jpg";